/**
 * purchaseRecord 状态枚举（与 server/constants/purchaseRecordStatus.js 保持一致）
 */

export const PURCHASE_RECORD_STATUS = {
  PENDING_CONFIRM: 0,
  PENDING_PURCHASE: 1,
  IN_PURCHASE: 2,
  COMPLETED: 3,
  VOID: -1,
};

export const PURCHASE_RECORD_STATUS_LABEL = {
  [PURCHASE_RECORD_STATUS.PENDING_CONFIRM]: "待确认",
  [PURCHASE_RECORD_STATUS.PENDING_PURCHASE]: "待采购",
  [PURCHASE_RECORD_STATUS.IN_PURCHASE]: "采购中",
  [PURCHASE_RECORD_STATUS.COMPLETED]: "已完成",
  [PURCHASE_RECORD_STATUS.VOID]: "已作废",
};

export const REFUND_STATUS = {
  NONE: 0,
  NO_NEED: 1,
  PENDING: 2,
  DONE: 3,
};

export const REFUND_STATUS_LABEL = {
  [REFUND_STATUS.NONE]: "",
  [REFUND_STATUS.NO_NEED]: "无需退款",
  [REFUND_STATUS.PENDING]: "待退款",
  [REFUND_STATUS.DONE]: "已退款",
};

export const RETURN_STATUS = {
  NONE: 0,
  NO_NEED: 1,
  PENDING: 2,
  DONE: 3,
};

export const RETURN_STATUS_LABEL = {
  [RETURN_STATUS.NONE]: "",
  [RETURN_STATUS.NO_NEED]: "无需退货",
  [RETURN_STATUS.PENDING]: "待退货",
  [RETURN_STATUS.DONE]: "已退货",
};

export const STATUS_TABS = [
  { name: String(PURCHASE_RECORD_STATUS.PENDING_CONFIRM), code: PURCHASE_RECORD_STATUS.PENDING_CONFIRM, label: "待确认" },
  { name: String(PURCHASE_RECORD_STATUS.PENDING_PURCHASE), code: PURCHASE_RECORD_STATUS.PENDING_PURCHASE, label: "待采购" },
  { name: String(PURCHASE_RECORD_STATUS.IN_PURCHASE), code: PURCHASE_RECORD_STATUS.IN_PURCHASE, label: "采购中" },
  { name: String(PURCHASE_RECORD_STATUS.COMPLETED), code: PURCHASE_RECORD_STATUS.COMPLETED, label: "已完成" },
  { name: String(PURCHASE_RECORD_STATUS.VOID), code: PURCHASE_RECORD_STATUS.VOID, label: "已作废" },
  { name: "all", code: "", label: "全部" },
];

export const VOIDABLE_STATUSES = [PURCHASE_RECORD_STATUS.PENDING_CONFIRM, PURCHASE_RECORD_STATUS.PENDING_PURCHASE];
export const CONFIRMABLE_STATUSES = [PURCHASE_RECORD_STATUS.PENDING_CONFIRM];
export const CREATABLE_ORDER_STATUSES = [PURCHASE_RECORD_STATUS.PENDING_PURCHASE];
export const REJECTABLE_STATUSES = [PURCHASE_RECORD_STATUS.PENDING_PURCHASE];
export const EDITABLE_STATUSES = [PURCHASE_RECORD_STATUS.PENDING_CONFIRM];

export function getPurchaseRecordStatusLabel(status) {
  if (status === "" || status === null || status === undefined) return "";
  const code = Number(status);
  return PURCHASE_RECORD_STATUS_LABEL[code] || "";
}

export function getRefundStatusLabel(status) {
  if (status === "" || status === null || status === undefined) return "";
  const code = Number(status);
  if (code === REFUND_STATUS.NONE) return "";
  return REFUND_STATUS_LABEL[code] || "";
}

export function getReturnStatusLabel(status) {
  if (status === "" || status === null || status === undefined) return "";
  const code = Number(status);
  if (code === RETURN_STATUS.NONE) return "";
  return RETURN_STATUS_LABEL[code] || "";
}

export function canVoidPurchaseRecord(status) {
  if (status === "" || status === null || status === undefined) return false;
  const code = Number(status);
  if (Number.isNaN(code)) return false;
  return VOIDABLE_STATUSES.includes(code);
}

export function canConfirmPurchaseRecord(status) {
  return CONFIRMABLE_STATUSES.includes(Number(status));
}

export function canCreatePurchaseOrder(status) {
  return CREATABLE_ORDER_STATUSES.includes(Number(status));
}

export function canRejectPurchaseRecord(status) {
  return REJECTABLE_STATUSES.includes(Number(status));
}

export function canEditPurchaseRecord(status) {
  return EDITABLE_STATUSES.includes(Number(status));
}

export const FULFILLMENT_CLOSE_FILTER_OPTIONS = [
  { value: "", label: "全部" },
  { value: "closed", label: "收货已结案" },
  { value: "pending_close", label: "待结案" },
  { value: "qty_matched", label: "数量齐" },
  { value: "qty_mismatched", label: "数量不一致" },
];

export function getFulfillmentCloseTagType(flag) {
  if (flag === "closed") return "success";
  if (flag === "pending_close") return "warning";
  if (flag === "qty_mismatched") return "danger";
  return "info";
}
